import { Model } from '@vuex-orm/core';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class Volunteer extends Model {
    static entity = 'volunteers'

    static primaryKey = 'id'

    static fields () {
      return {
        id: this.attr(null),
        name: this.string(null)
      };
    }

    /**
     * Axios default overrides
     * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
     */
    static methodConf = {
      http: {
        url: 'regicall/volunteers'
      },
      methods: {
      }
    }
}
